import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="text-[#c9a84c] font-display font-bold text-xl mb-3">{title}</h2>
    <div className="text-[#9a9890] text-sm leading-relaxed space-y-3">{children}</div>
  </div>
);

const Toggle = ({ label, description, defaultOn = false, disabled = false }) => {
  const [on, setOn] = useState(defaultOn);
  return (
    <div className="flex items-start justify-between gap-4 py-4 border-b border-white/5">
      <div>
        <p className="text-white text-sm font-semibold">{label}</p>
        <p className="text-[#7a7870] text-xs mt-0.5">{description}</p>
      </div>
      <button
        onClick={() => !disabled && setOn(v => !v)}
        className="flex-shrink-0 w-10 h-6 rounded-full transition-colors duration-300 relative"
        style={{ backgroundColor: on ? '#c9a84c' : '#2a2a30', cursor: disabled ? 'not-allowed' : 'pointer' }}
        aria-label={label}
      >
        <span className="absolute top-1 left-1 w-4 h-4 rounded-full bg-white transition-transform duration-300"
          style={{ transform: on ? 'translateX(16px)' : 'translateX(0)' }} />
      </button>
    </div>
  );
};

export const Cookies = () => (
  <div className="min-h-screen" style={{ background: '#050508', color: '#e8e6e0' }}>
    <nav className="px-6 md:px-12 py-5 flex items-center gap-3 border-b border-white/5">
      <Link to="/" className="flex items-center gap-3">
        <div className="w-9 h-9 rounded-xl flex items-center justify-center" style={{ background: '#0d0d10', border: '1.5px solid rgba(201,168,76,0.3)' }}>
          <svg viewBox="0 0 40 40" width="24" height="24" fill="none">
            <polygon points="20,5 4,18 36,18" fill="#f0c040"/>
            <rect x="26" y="8" width="4" height="8" fill="#f0c040"/>
            <rect x="7" y="18" width="26" height="17" fill="#f0c040"/>
            <rect x="15" y="25" width="10" height="10" fill="#050508" rx="1"/>
            <circle cx="23" cy="30" r="1" fill="#c9a84c"/>
            <rect x="9" y="20" width="7" height="6" fill="#050508" rx="1"/>
            <rect x="24" y="20" width="7" height="6" fill="#050508" rx="1"/>
          </svg>
        </div>
        <span className="font-display font-bold text-white tracking-tight">E-<span className="text-[#c9a84c]">HOME</span></span>
      </Link>
    </nav>

    <main className="max-w-3xl mx-auto px-6 py-16">
      <div className="mb-12">
        <p className="text-[#c9a84c] text-xs font-semibold uppercase tracking-widest mb-3">Legal</p>
        <h1 className="font-display font-black text-4xl md:text-5xl text-white mb-4">Política de Cookies</h1>
        <p className="text-[#7a7870] text-sm">Última actualización: 25 de abril de 2026</p>
      </div>

      <Section title="¿Qué son las cookies?">
        <p>Las cookies son pequeños archivos de texto que se almacenan en tu dispositivo cuando visitas un sitio web. Nos permiten recordar tus preferencias, mantener tu sesión activa y mejorar la experiencia de uso de E-HOME.</p>
      </Section>

      <Section title="Tipos de cookies que utilizamos">
        <div className="rounded-xl overflow-hidden" style={{ border: '1px solid rgba(201,168,76,0.15)' }}>
          <Toggle label="Cookies esenciales" description="Necesarias para el funcionamiento de la plataforma. No se pueden desactivar." defaultOn disabled />
          <Toggle label="Cookies de análisis" description="Nos ayudan a entender cómo se usa la plataforma (PostHog). Datos agregados y anonimizados." defaultOn={false} />
          <Toggle label="Cookies de preferencias" description="Recuerdan tu idioma, tema y configuración de interfaz." defaultOn={true} />
        </div>
      </Section>

      <Section title="Cookies de terceros">
        <p>Utilizamos <strong className="text-white">PostHog</strong> para análisis de uso con privacidad prioritaria (sin venta de datos). Las sesiones están configuradas para no compartir datos entre dominios.</p>
      </Section>

      <Section title="Cómo gestionar las cookies">
        <p>Puedes configurar tu navegador para bloquear o eliminar cookies. Ten en cuenta que desactivar las cookies esenciales puede afectar al funcionamiento de la plataforma. Consulta la ayuda de tu navegador para más información.</p>
      </Section>

      <Section title="Contacto">
        <p>Para cualquier consulta sobre el uso de cookies, escríbenos a <a href="mailto:info@iaconsultora.com" className="text-[#c9a84c] hover:underline">info@iaconsultora.com</a>.</p>
      </Section>
    </main>

    <footer className="border-t border-white/5 px-6 py-8 text-center">
      <p className="text-[#7a7870] text-xs">© 2026 ehomesp.com · <Link to="/privacidad" className="hover:text-[#c9a84c] transition-colors">Privacidad</Link> · <Link to="/cookies" className="hover:text-[#c9a84c] transition-colors">Cookies</Link> · <Link to="/contacto" className="hover:text-[#c9a84c] transition-colors">Contacto</Link></p>
    </footer>
  </div>
);

export default Cookies;
